import { Component, Input, NgModule } from '@angular/core';
import { LoggingService, MobilePassService, MobilePassQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MobilePassModalComponent } from '@fgb/portal-component-library/src/lib/passes/mobile-pass-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-device-detector';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc7 from '@ngx-translate/core';

function MobilePassComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 1);
    ɵngcc0.ɵɵlistener("click", function MobilePassComponent_ng_container_0_ng_container_1_ng_container_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const mobilePass_r1 = ɵngcc0.ɵɵnextContext(2).ngIf; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.downloadPassDesktop(mobilePass_r1.data.url); });
    ɵngcc0.ɵɵtext(2, "Download Mobile Pass");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_hr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hr", 4);
} }
function MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "a", 6);
    ɵngcc0.ɵɵelementStart(2, "label", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 8);
    ɵngcc0.ɵɵelement(6, "img", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mobilePass_r1 = ɵngcc0.ɵɵnextContext(3).ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", mobilePass_r1.data.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "mobile.pass.android.screenreader"));
} }
function MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "a", 6);
    ɵngcc0.ɵɵelementStart(2, "label", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 11);
    ɵngcc0.ɵɵelement(6, "img", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mobilePass_r1 = ɵngcc0.ɵɵnextContext(3).ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", mobilePass_r1.data.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "mobile.pass.ios.screenreader"));
} }
function MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_hr_1_Template, 1, 0, "hr", 2);
    ɵngcc0.ɵɵtemplate(2, MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_div_2_Template, 7, 4, "div", 3);
    ɵngcc0.ɵɵtemplate(3, MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_div_3_Template, 7, 4, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.separateTop);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.deviceDetector.os.toUpperCase() === "ANDROID");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.deviceDetector.os.toUpperCase() === "IOS");
} }
function MobilePassComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MobilePassComponent_ng_container_0_ng_container_1_ng_container_1_Template, 3, 0, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, MobilePassComponent_ng_container_0_ng_container_1_ng_container_2_Template, 4, 3, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.deviceDetector.isDesktop());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.deviceDetector.isMobile());
} }
function MobilePassComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label", 13);
    ɵngcc0.ɵɵtext(3, "Mobile Pass Unavailable");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function MobilePassComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mobilePass_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("Error ", mobilePass_r1.error, "");
} }
function MobilePassComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-loading");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function MobilePassComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MobilePassComponent_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, MobilePassComponent_ng_container_0_ng_container_2_Template, 4, 0, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, MobilePassComponent_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(4, MobilePassComponent_ng_container_0_ng_container_4_Template, 2, 0, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mobilePass_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mobilePass_r1.data);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mobilePass_r1.isEmpty);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mobilePass_r1.error);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mobilePass_r1.isLoading);
} }
class MobilePassComponent {
    constructor(deviceDetector, loggingService, modalService, mobilePassService, mobilePassQuery) {
        this.deviceDetector = deviceDetector;
        this.loggingService = loggingService;
        this.modalService = modalService;
        this.mobilePassService = mobilePassService;
        this.mobilePassQuery = mobilePassQuery;
        this.separateTop = false;
    }
    ngOnInit() {
        this.mobilePassService.fetchPass(this.memberId).toPromise();
        this.mobilePassUrl$ = this.mobilePassQuery.selectFirst();
    }
    downloadPassDesktop(url) {
        if (!this.deviceDetector.isMobile()) {
            // Produce a QR code for the mobile link so a user is redirected to the mobile link
            // when scanning on their phone.
            this.loggingService.info('Desktop detected, formatting QR code.');
            const modal = this.modalService.open(MobilePassModalComponent);
            modal.componentInstance.url = url;
        }
    }
}
MobilePassComponent.ɵfac = function MobilePassComponent_Factory(t) { return new (t || MobilePassComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DeviceDetectorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LoggingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MobilePassService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MobilePassQuery)); };
MobilePassComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MobilePassComponent, selectors: [["fgbcl-mobile-pass"]], inputs: { separateTop: "separateTop", memberId: "memberId" }, decls: 3, vars: 5, consts: [[4, "ngIf"], [1, "btn", "btn-danger", 3, "click"], ["class", "horizontal-bar", 4, "ngIf"], ["class", "d-flex justify-content-center py-2", 4, "ngIf"], [1, "horizontal-bar"], [1, "d-flex", "justify-content-center", "py-2"], ["target", "_blank", 3, "href"], ["for", "android-pass", 1, "accessibility-only"], ["id", "android-pass", 1, "btn", "btn-android"], ["src", "assets/images/passes/google.svg"], ["for", "apple-pass", 1, "accessibility-only"], ["id", "apple-pass", 1, "btn"], ["src", "assets/images/passes/apple.svg"], [1, "mb-0"]], template: function MobilePassComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MobilePassComponent_ng_container_0_Template, 5, 4, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵpipe(2, "withLoading");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ɵngcc0.ɵɵpipeBind1(2, 3, ctx.mobilePassUrl$)));
    } }, directives: [ɵngcc4.NgIf, ɵngcc5.LoadingComponent], pipes: [ɵngcc4.AsyncPipe, ɵngcc6.WithLoadingPipe, ɵngcc7.TranslatePipe], styles: [".btn-android[_ngcontent-%COMP%]{background-color:#fff}.horizontal-bar[_ngcontent-%COMP%]{width:90%;margin:0 auto;border-bottom:1px solid #fff}"] });
MobilePassComponent.ctorParameters = () => [
    { type: DeviceDetectorService },
    { type: LoggingService },
    { type: NgbModal },
    { type: MobilePassService },
    { type: MobilePassQuery }
];
MobilePassComponent.propDecorators = {
    memberId: [{ type: Input }],
    separateTop: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobilePassComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-mobile-pass',
                template: "<ng-container *ngIf=\"mobilePassUrl$ | withLoading | async as mobilePass\">\r\n  <!-- Mobile Pass available-->\r\n  <ng-container *ngIf=\"mobilePass.data\">\r\n    <!--Desktop-->\r\n    <ng-container *ngIf=\"deviceDetector.isDesktop()\">\r\n      <button class=\"btn btn-danger\" (click)=\"downloadPassDesktop(mobilePass.data.url)\">Download Mobile Pass</button>\r\n    </ng-container>\r\n    <!--Mobile-->\r\n    <ng-container *ngIf=\"deviceDetector.isMobile()\">\r\n      <hr *ngIf=\"separateTop\" class=\"horizontal-bar\" />\r\n      <!--ANDROID-->\r\n      <div class=\"d-flex justify-content-center py-2\" *ngIf=\"deviceDetector.os.toUpperCase() === 'ANDROID'\">\r\n        <a [href]=\"mobilePass.data.url\" target=\"_blank\">\r\n          <label for=\"android-pass\" class=\"accessibility-only\">{{ 'mobile.pass.android.screenreader' | translate }}</label>\r\n          <button id=\"android-pass\" class=\"btn btn-android\">\r\n            <img src=\"assets/images/passes/google.svg\" />\r\n          </button>\r\n        </a>\r\n      </div>\r\n      <!--IOS-->\r\n      <div class=\"d-flex justify-content-center py-2\" *ngIf=\"deviceDetector.os.toUpperCase() === 'IOS'\">\r\n        <a [href]=\"mobilePass.data.url\" target=\"_blank\">\r\n          <label for=\"apple-pass\" class=\"accessibility-only\">{{ 'mobile.pass.ios.screenreader' | translate }}</label>\r\n          <button id=\"apple-pass\" class=\"btn\">\r\n            <img src=\"assets/images/passes/apple.svg\" />\r\n          </button>\r\n        </a>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n\r\n  <!-- No Mobile Pass available -->\r\n  <ng-container *ngIf=\"mobilePass.isEmpty\">\r\n    <div class=\"d-flex justify-content-center py-2\">\r\n      <label class=\"mb-0\">Mobile Pass Unavailable</label>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <!-- Error -->\r\n  <ng-container *ngIf=\"mobilePass.error\">Error {{ mobilePass.error }}</ng-container>\r\n\r\n  <!-- Loading Pass-->\r\n  <ng-container *ngIf=\"mobilePass.isLoading\">\r\n    <fgbcl-loading></fgbcl-loading>\r\n  </ng-container>\r\n</ng-container>\r\n",
                styles: [".btn-android{background-color:#fff}.horizontal-bar{width:90%;margin:0 auto;border-bottom:1px solid #fff}"]
            }]
    }], function () { return [{ type: ɵngcc1.DeviceDetectorService }, { type: ɵngcc2.LoggingService }, { type: ɵngcc3.NgbModal }, { type: ɵngcc2.MobilePassService }, { type: ɵngcc2.MobilePassQuery }]; }, { separateTop: [{
            type: Input
        }], memberId: [{
            type: Input
        }] }); })();

class MobilePassModule {
}
MobilePassModule.ɵfac = function MobilePassModule_Factory(t) { return new (t || MobilePassModule)(); };
MobilePassModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MobilePassModule });
MobilePassModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            LoadingModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MobilePassModule, { declarations: function () { return [MobilePassComponent]; }, imports: function () { return [CommonModule,
        PipesModule,
        LoadingModule, ɵngcc7.TranslateModule]; }, exports: function () { return [MobilePassComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobilePassModule, [{
        type: NgModule,
        args: [{
                declarations: [MobilePassComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    LoadingModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MobilePassComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MobilePassComponent, MobilePassModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-passes-mobile-pass.js.map